import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  avatars: [],
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setAvatars: (state, action) => {
      state.avatars = action.payload;
    },
  },
});

export const { setAvatars } = appSlice.actions;

export default appSlice.reducer;
